<h2 mat-dialog-title>Create New Announcement</h2>
<mat-dialog-content>
  <div class="form-container">
    <mat-form-field name="typeField" class="half-width">
      <mat-label>Type</mat-label>
      <mat-select name="selectedType" ngDefaultControl [(ngModel)]="selectedType">
        @for (type of announcementTypes; track type) {
          <mat-option [value]="type">{{ type }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field name="titleField" class="half-width">
      <mat-label>Title</mat-label>
      <input matInput name="announcementTitle" ngDefaultControl [(ngModel)]="announcementTitle">
    </mat-form-field>
    <div class="announcement-content half-width">
      <div class="editor-container">
        <textarea
          class="content-editor"
          placeholder="Announcement Content"
          [(ngModel)]="announcementContent">
        </textarea>
        <div class="markdown-preview">
          <h1>Announcement Preview</h1>
          <markdown [data]="announcementContent"></markdown>
        </div>
      </div>
      <a href="https://www.markdownguide.org/cheat-sheet/" target="_blank" rel="noopener">Markdown Cheat Sheet</a>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="button" (click)="onNoClick()">Cancel</button>
  <button mat-raised-button class="button" (click)="submitAnnouncement()">Submit</button>
</mat-dialog-actions>